import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
// import Loaders from "../Loaders";
import BreadcrumTop from "../BreadcrumTop";
import Swal from "sweetalert2";
import { getToken } from "../../../utils/getToken";
import { API_ROUTES } from "../../../utils/constants";

export default function CreateCompany(props) {
  const { isLoaded, setIsLoaded } = props;

  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Toggle password visibility
  const togglePassword = () => setShowPassword(!showPassword);

  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.rowData;
  // console.log("company", rowData);
  useEffect(() => {
    if (rowData) {
      // console.log("company id", rowData);
      // console.log("company id", rowData.id);
      setCompanyId(rowData.id || "");
      setCompanyName(rowData.companyName || "");
      setEmail(rowData.email || "");
      setUsername(rowData.userName || "");
    }
  }, [rowData]);

  useEffect(() => {
    if (window.eduMin) {
      window.eduMin.load();
    } else {
      console.warn("eduMin is not defined");
    }
  }, []);

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    Promise.all([loadScript("../assets/libs_/js/custom.min.js")])
      .then(() => {
        // Both scripts are loaded
      })
      .catch((error) => {
        console.error("Error loading scripts:", error);
      });
    return () => {
      // Remove the scripts here if necessary
    };
  }, []);

  // Validation function
  const validateForm = () => {
    if (!companyName) return showError("Company Name is required.");
    if (!username) return showError("User Name is required.");
    if (!email) return showError("Email is required.");
    if (!email.includes("@"))
      return showError("Please enter a valid email address.");

    return true;
  };

  const showError = (message) => {
    Swal.fire({ title: "Error", text: message, icon: "error" });
    return false;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });

      // Clear specific items from local storage
      localStorage.removeItem("companyName");
      localStorage.removeItem("userVASData");

      // Redirect to the login page
      navigate("/login");
      return;
    }

    setLoading(true);
    const formData = {
      username,
      companyName,
      email,
      companyId,
    };
    // console.log("form data to submit", formData);

    try {
      const url = `${API_ROUTES.UPDATE_COMPANY}/${encodeURIComponent(
        companyId
      )}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        if (response.status === 401) {
          // Show SweetAlert
          Swal.fire({
            title: "Unauthorized",
            text: "Please log in again.",
            icon: "error",
          }).then(() => {
            // Clear data from local storage
            localStorage.removeItem("userVASData");
            localStorage.removeItem("companyName");
            // Redirect the user to the login page
            navigate("/login");
          });
        } else {
          Swal.fire({
            title: "<span className='error_title'>Error</span>",
            html:
              errorMessages[response.status] || `Unexpected error occurred.`,
            icon: "error",
          });
        }

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();

      if (response.ok) {
        Swal.fire({
          title: "Success",
          text: "Company updated successfully.",
          icon: "success",
        }).then(() => {
          // After clicking OK on the SweetAlert, navigate with the companyId
          navigate("/company");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Unable to update company.",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Loaders isLoaded={isLoaded} /> */}

      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body">
          <div className="container-fluid">
            <BreadcrumTop title="Update Company" />

            <div className="row">
              <div className="d-flex justify-content-center align-items-center">
                <div className="col-xl-7 col-lg-10 col-md-10">
                  <div className="card">
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="mb-2 row">
                          <div className="col-sm-10 offset-sm-2">
                            <p className="text-danger">
                              All fields are compulsory
                            </p>
                            {/* {companyId} */}
                          </div>
                        </div>
                        <input
                          type="hidden"
                          name="companyId"
                          value={companyId}
                          className="text-dark"
                        />
                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Company Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="companyName"
                              value={companyName}
                              onChange={(e) => setCompanyName(e.target.value)}
                              className="form-control"
                              placeholder="Enter companyNamee"
                              // required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            User Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              className="form-control"
                              placeholder="Enter username"
                              // required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Email
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="email"
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              placeholder="Enter email"
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="mb-3 mt-4 row">
                          <div className="col-sm-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary m-1"
                              disabled={loading}
                            >
                              {loading ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "Update Company"
                              )}
                            </button>
                            {/* <Link
                            to="/marketers"
                            // state={{ rowData: { companyId: companyId } }}
                            state={{ rowData: { id: companyId } }}
                            className="btn btn-dark m-1"
                          >
                            Go Back
                          </Link> */}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
